'use strict';

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Node = require('./node');

var Term =
/*#__PURE__*/
function (_Node) {
  _inherits(Term, _Node);

  _createClass(Term, null, [{
    key: "termByStoreIndex",

    /**
     * Retrieve a term (NamedNode, BlankNode or Literal) by its store index
     * @param sI {integer} The store index of the term
     * @return {BlankNode|NamedNode|Literal|undefined}
     */
    value: function termByStoreIndex(sI) {
      return Term.termMap[sI];
    }
  }]);

  function Term() {
    var _this;

    _classCallCheck(this, Term);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Term).call(this)); // Complete the object shape https://stackoverflow.com/a/44467873

    _this.sI = undefined;
    _this.string = "";
    return _this;
  }

  _createClass(Term, [{
    key: "equals",
    value: function equals(other) {
      return other === this;
    }
  }, {
    key: "hashString",
    value: function hashString() {
      return this.sI;
    }
  }, {
    key: "sameTerm",
    value: function sameTerm(other) {
      return other === this;
    }
  }, {
    key: "generateString",
    value: function generateString() {
      return "".concat(this.value);
    }
  }, {
    key: "toString",
    value: function toString() {
      if (!this.string) {
        this.string = this.generateString();
      }

      return this.string;
    }
  }]);

  return Term;
}(Node);
/**
 * Running counter which assigns ids
 * @package
 * @type {number}
 */


Term.termIndex = 0;
/**
 * Maps terms to their (integer) index
 * @type {Array<BlankNode | NamedNode>}
 */

Term.termMap = [];
/**
 * Maps IRIs to their NamedNode counterparts
 * @package
 * @type {Object<string, NamedNode>}
 */

Term.nsMap = {};
/**
 * Maps blank ids to their BlankNode counterparts
 * @package
 * @type {Object<string, BlankNode>}
 */

Term.bnMap = {};
/**
 * Maps literals to their Literal counterparts
 * @package
 * @type {Array<Array<Literal|Array<Literal>>>}
 */

Term.litMap = [];
module.exports = Term;